import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { RmaItemExModel, RmaRequestModel } from 'src/app/shared/models/rma.model';
import { RmaMasterService } from 'src/app/shared/services/rma-master.service';
import { EditProductItemComponent } from './edit-product-item/edit-product-item.component';
import { EditSRProductItemComponent } from './edit-sr-product-item/edit-sr-product-item.component';

@Component({
  selector: 'app-add-product-step',
  templateUrl: './add-product-step.component.html',
  styleUrls: ['./add-product-step.component.css']
})
export class AddProductStepComponent implements OnInit {
  @Input() rmarequest : RmaRequestModel;
  @Output() onNextStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrevStep: EventEmitter<any> = new EventEmitter<any>();
  dialogConfig = new MatDialogConfig();

  constructor(private service : RmaMasterService,
    //private toastr : ToastrService,
    private dialog : MatDialog) {


      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "50%";
      this.dialogConfig.minWidth="400px";
      this.dialogConfig.maxWidth="600px";
    }


  ngOnInit() {
  }


  onNext()
  {
    this.onNextStep.emit(this.rmarequest);
  }

  onBack()
  {
    this.onPrevStep.emit(this.rmarequest);
  }

  isStockRotation()
  {
    return GlobalConstants.isStockRotationType(this.rmarequest.rma.rmaTypeRequested)
  }

  onAddProduct()
  {
    console.log("onAddProduct");
    this.service.initializeFormGroup();
    this.dialogConfig.data = {
      result : false,
      rmaitem : null,
      product : null,
    };

    if(this.isStockRotation())
      this.openEditSRProductPopup(null);
    else
      this.openEditProductPopup(null);
  }

  openEditProductPopup(item)
  {
    let dialogRef = this.dialog.open(EditProductItemComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      console.log("result onAddProduct");
      if(this.dialogConfig.data.result && this.dialogConfig.data.rmaitem != null)
      {
        if(item)
        {
          item.rmaitem = this.dialogConfig.data.rmaitem;
          item.product = this.dialogConfig.data.product;
        }
        else{
          var newitem = new RmaItemExModel();
          newitem.rmaitem = this.dialogConfig.data.rmaitem;
          newitem.product = this.dialogConfig.data.product;
          this.rmarequest.rmaitems.push(newitem);
        }

        newitem.rmaitem.snList = new Array();
        newitem.rmaitem.snList.push(newitem.rmaitem.sn);
      }

    });
  }

  openEditSRProductPopup(item)
  {
    //alert("This is not supported yet.");
    //return;
    let dialogRef = this.dialog.open(EditSRProductItemComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      console.log("result onAddProduct");
      if(this.dialogConfig.data.result && this.dialogConfig.data.rmaitem != null)
      {
        if(item)
        {
          item.rmaitem = this.dialogConfig.data.rmaitem;
          item.product = this.dialogConfig.data.product;
        }
        else{
          var newitem = new RmaItemExModel();
          newitem.rmaitem = this.dialogConfig.data.rmaitem;
          newitem.product = this.dialogConfig.data.product;
          this.rmarequest.rmaitems.push(newitem);
          //this.refreshList();
        }
      }

    });

  }


  onDelete(item)
  {
    this.rmarequest.rmaitems.splice(this.rmarequest.rmaitems.indexOf(item), 1);
  }

  onEdit(item)
  {
    console.log("onEdit");
    this.service.populateForm(item.rmaitem);
    this.dialogConfig.data = {
      result : false,
      rmaitem : item.rmaitem,
      product : item.product,
    };

    if(this.isStockRotation())
      this.openEditSRProductPopup(item);
    else
      this.openEditProductPopup(item);
  }

}
